import React from "react";

export const SetIsAdditionalOfferOpenCtxProviderForParentLayout =
	React.createContext<{
		setIsAdditionalOpen: (isAdditionalOpen: boolean) => void;
		isAdditionalOpen: boolean;
	}>({ setIsAdditionalOpen: () => {}, isAdditionalOpen: false });
